// import Cookies from 'js-cookie'
import { getSidebarData, updateSidebarData } from '@/api/newdata'

const newdata = {
  state: {
    total: 0,
    rows: [],
    row: {}
  },
  mutations: {
    SET_TOTAL: (state, total) => {
      state.total = total
    },
    SET_ROWS: (state, rows) => {
      state.rows = rows
    },
    SET_ROW: (state, row) => {
      state.row = row
    }
  },
  actions: {
    // 查询
    GetSidebarData({ commit }, params) {
      return new Promise((resolve, reject) => {
        getSidebarData(params).then(response => {
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 修改
    UpdateSidebarData({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateSidebarData(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default newdata



// WEBPACK FOOTER //
// ./src/store/modules/newdata.js